var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#1890FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0254 7.47186L18.0254 7.47186C17.7271 7.17605 17.2443 7.17605 16.946 7.47186L9.94286 14.4167L7.05398 11.5519C6.75568 11.256 6.2729 11.256 5.9746 11.5519L6.15063 11.7294L5.9746 11.5519C5.67514 11.8488 5.67513 12.3312 5.9746 12.6281L9.40317 16.0281C9.70147 16.324 10.1842 16.324 10.4825 16.0281L18.0254 8.54814C18.3249 8.25117 18.3249 7.76883 18.0254 7.47186Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlueIcon);
export default __webpack_public_path__ + "static/media/check_blue_icon.e995705c.svg";
export { ForwardRef as ReactComponent };